import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../../../';

export const selectReleaseNotes = (state: RootState) => state.releaseNotes.releaseNotes;
export const selectMeta = (state: RootState) => state.releaseNotes.meta;
export const selectLoading = (state: RootState) => state.releaseNotes.loading;

export const isReleaseNotesLoadedSelector = createSelector(
  [selectMeta],
  (meta) => meta.currentPage >= meta.lastPage,
);

export const nextRequestParamsSelector = createSelector(
  [selectMeta],
  (meta) => ({
    per_page: meta.perPage,
    page: meta.currentPage + 1,
  }),
);
